import { TRIP_STATUS_FILTER_OPTIONS } from 'utils/constants/transport';

export const filters = ({ bizClients }) => {
  return {
    RegularFilters: [
      {
        label: 'status',
        field: 'status',
        type: 'select',
        options: TRIP_STATUS_FILTER_OPTIONS,
        multiple: true,
        placeholder: '',
      },
      {
        label: 'businessClient',
        field: 'businessClient',
        type: 'select',
        options: bizClients,
      },
      {
        label: 'dateFrom',
        field: 'dateFrom',
        type: 'date-picker',
      },
      {
        label: 'dateTo',
        field: 'dateTo',
        type: 'date-picker',
      },
    ],
  };
};
